import { render } from "./FutureDestinations.vue?vue&type=template&id=e935bbe8"
import script from "./FutureDestinations.vue?vue&type=script&lang=js"
export * from "./FutureDestinations.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__